module.exports = __webpack_public_path__ + "media/assets/icons/eye-1aa65fe06268f9539d8abaf805ec143c.svg";